import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-base-route',
  templateUrl: './base-route.component.html',
  styleUrl: './base-route.component.scss',
  imports: [RouterOutlet],
})
export class BaseRouteComponent {}
